import React, { Component, useState, Fragment } from "react";
import settings from '../assets/settings.json';
import InputGroup from 'react-bootstrap/InputGroup';
import { Modal, Button, Form } from "react-bootstrap";
import Cookies from 'js-cookie'
import {addCmListFunction} from '../cm_parts/js/CmListFunction';
import {addEveryoneFunction} from '../cm_parts/js/EveryoneFunction';

import '../cm_parts/css/everyone.css';

export default class Everyone extends Component{

  state={
    isit_ok_user:false,
    pin:null,
    order_data_url:null,
    staff_name:null,
    staff_token:null,

    order_data_files:[],
    dw_url_order_data:null,
    latest_order_data:null,
    latest_order_data_fix:null,
    latest_order_data_who:null,
    isit_change:false,

    open_history:false,
    history_title:null,
    history_url_param:null,
    
    dw_bt_clicked:false
  }

  componentDidMount () {
    let staff_token = Cookies.get('_replace_token');
		let staff_name = Cookies.get('_replace_staff');

    if(staff_name===undefined && staff_token===undefined){
      staff_token = 'everyone';
      staff_name = 'everyone';
    }else{
      this.setState({isit_ok_user:true});
    }
    
    this.setState({staff_name:staff_name});
    this.setState({staff_token:staff_token});

  
    const url_tonya_hattyuu_date_stream = settings.API_BASE_URL + 'download_csv_list/' + '?what_type=order_data&token='+staff_token+'&name='+ staff_name;
		this.eventSource = new EventSource(url_tonya_hattyuu_date_stream);
    this.eventSource.addEventListener('message', this.handleMessage);


    // Stream 最初遅い
    let api_url = settings.API_BASE_URL + 'download_csv_list_first/' + '?what_type=order_data&token='+staff_token+'&name='+ staff_name;
    //console.log(api_url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText);
    //console.dir(response_obj);
    let order_data_files = [];
    if(response_obj['data']['obj'].length>0){
      order_data_files = response_obj['data']['obj'];
    }
    //console.dir(order_data_files);
    order_data_files = addEveryoneFunction.convertObjtoArray(order_data_files);
    //console.dir(order_data_files);
    this.setState({order_data_files:order_data_files});

    if(order_data_files.length>0){
      let dw_url_order_data = settings.API_BASE_URL + 'download_csv/' + '?what_type=order_data&file_id='+order_data_files[0][4]+'&token='+staff_token+'&name='+ staff_name;
      this.setState({dw_url_order_data:dw_url_order_data});

      console.dir(order_data_files[0]);
      let _latest = order_data_files[0][5];
      _latest = addCmListFunction.convertDate('', _latest);
      this.setState({latest_order_data:_latest});
      this.setState({latest_order_data_fix:order_data_files[0][5]});
      this.setState({latest_order_data_who:order_data_files[0][2]});
    }
    

  }


	componentWillUnmount() {
    this.eventSource.close();
  }

	handleMessage = async (event) => {
    //console.dir(event.data);
    console.log('stream file list');
    

    let file_request_datas = addEveryoneFunction.convertDbStringToArray(event.data);
    this.setState({order_data_files:file_request_datas});

    if(file_request_datas.length>0){
      let dw_url_order_data = settings.API_BASE_URL + 'download_csv/' + '?what_type=order_data&file_id='+file_request_datas[0][4]+'&token='+this.state.staff_token+'&name='+ this.state.staff_name;
      this.setState({dw_url_order_data:dw_url_order_data});
      //console.dir(file_request_datas[0]);
      let _latest = file_request_datas[0][5];
      _latest = addCmListFunction.convertDate('', _latest);
      this.setState({latest_order_data:_latest});
      this.setState({latest_order_data_fix:new Date(file_request_datas[0][5])}); // created
      this.setState({latest_order_data_who:file_request_datas[0][2]}); // who

      if(this.state.latest_order_data_fix!==null){
        if(this.state.latest_order_data_fix<new Date(file_request_datas[0][5])){
          console.log('file update!');
          this.setState({isit_change:true});
          this.setState({latest_order_data:null});
          addEveryoneFunction.changeFavicon('green');

          this.setState({dw_bt_clicked:false});
        }
      }

    }

  }


  closeHistoryBoard = async (e) => {
		this.setState({open_history:false});
	}



  render(){

		var handleInputChange = async (e) => {
			console.dir(e.target);
			if(e.target.name==='pin'){
        this.setState({pin:e.target.value});
        if(e.target.value==='ポッチ'){
          this.setState({isit_ok_user:true});
          Cookies.set('_replace_token', 'everyone', { expires: 30 })
          Cookies.set('_replace_staff', 'everyone', { expires: 30 })
        }
      }
    }


    var requestCreateFile = async (e) => {
      let api_url = null;
      if(e.target.id==='c_order_data'){
        api_url = settings.API_BASE_URL + 'download_csv_create/' + '?what_type=order_data&token='+this.state.staff_token+'&name='+ this.state.staff_name;
      }
      console.log(api_url);
      var Httpreq = new XMLHttpRequest();
      Httpreq.open("GET", api_url, false);
      Httpreq.send(null);
      var response_obj = JSON.parse(Httpreq.responseText);
      console.dir(response_obj);
      if(response_obj['data']['result']==='ok'){
        this.setState({latest_order_data_who:this.state.staff_name});
        //this.setState({latest_order_data:'wait'});
        this.setState({dw_bt_clicked:true});
      }
    }

    /*
    var requestDownload = async (e) => {
      let api_url = null;
      if(e.target.id==='dw_order_data'){
        api_url = settings.API_BASE_URL + 'download_csv/' + '?what_type=order_data&file_id='+this.state.order_data_files[0]['timestamp']+'&token='+this.state.staff_token+'&name='+ this.state.staff_name;
      }
      console.log(api_url);
      var Httpreq = new XMLHttpRequest();
      Httpreq.open("GET", api_url, false);
      Httpreq.send(null);
      var response_obj = JSON.parse(Httpreq.responseText);
      console.dir(response_obj);
    }
    */

    var requestHistory = async (e) => {
      this.setState({open_history:true});

      if(e.target.id==='h_order_data'){
        this.setState({history_title:'Order_data.xlsx'});
        this.setState({history_url_param:'order_data'})
      }
      
    }

    return (

      <div className="everyone small">
        {
          this.state.isit_ok_user ? 
            <>
              <h1>発注に関するデータ取得</h1>
              <table className="bg-light p-3 container">
                <tbody>
                  <tr>
                    <td>Menu</td>
                    <td>備考</td>
                    <td></td>
                    <td>直近分<i className="bi bi-download mx-3 click-pointer-elem"></i></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Order_date.xlsxの取得</td>
                    <td>リクエストボタン後、準備できましたらブラウザ・タブを緑色に変えます.<br/>他作業、もしくはしばらくして再度アクセスください.<br/>目安時間:2〜10分</td>
                    <td>
                      {this.state.dw_bt_clicked===false ? 
                        <>
                          <Button variant="primary" id="c_order_data" size="sm" className=""  onClick={event=>requestCreateFile(event)}>
			    	      	    		リクエストする
			    	      	    	</Button>
                        </> 
                        : 
                        <>
                          <Button variant="primary" id="c_order_data" size="sm" className="" disabled>
                            リクエスト済
                          </Button>
                        </>
                      }
                    </td>
                    <td>
                      {/* <Button variant="outline-primary" id="dw_order_data" size="sm" className=""  onClick={event=>requestDownload(event)}></Button> */}
                      <a href={this.state.dw_url_order_data} target="_blank" className="btn btn-sm btn-outline-primary position-relative">
                        {this.state.dw_bt_clicked===false ? 
                          <>
                            {this.state.latest_order_data}({this.state.latest_order_data_who})
                            {this.state.isit_change ? 
                              <>
                                <div className="my-badge">🟢</div>
                              </> : <></>}
                          </> 
                          : 
                          <>
                            <div className="spinner-border spinner-border-sm mx-1" role="status"><span className="sr-only"></span></div>
                            ({this.state.latest_order_data_who})
                          </>
                        }
                      </a>
				      	    	
                    </td>
                    <td>
                      {}
                      <Button variant="outline-primary" id="h_order_data" size="sm" className=""  onClick={event=>requestHistory(event)}>
				      	    		履歴
				      	    	</Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </> 
            : 
            <>
              <div className="p-4 box center">
                <h2>リプレイスのページです</h2>
                <p>PIN</p>
                <input
									type="text"
									name="pin"
									className="form-control form-control-sm input-w-m border border-primary text-center width-auto"
									value={this.state.pin}
									onChange={event=>handleInputChange(event)}
								/>
              </div>
            </>
        }



        {this.state.open_history ? 
          <div className="jan-info-content file_history text-center">
            <div className="my-2">{this.state.history_title}　の履歴</div>
            <table>
              <tbody>
                <tr><th>種類</th><th>日時</th><th>誰</th><th>ダウンロード</th></tr>
                {this.state.order_data_files.map((row, i)=>{
                  let this_date = addCmListFunction.convertDate('', this.state.order_data_files[i][5]);
                  let dw_url = settings.API_BASE_URL + 'download_csv/' + '?what_type=' + this.state.history_url_param + '&file_id='+this.state.order_data_files[i][4]+'&token='+this.state.staff_token+'&name='+ this.state.staff_name;

          	    	return(
						    		<tr key={i}>
                      <td>{this.state.order_data_files[i][1]}</td>
                      <td>{this_date}</td>
                      <td>{this.state.order_data_files[i][2]}</td>
                      <td>
                        <a href={dw_url} target="_blank" className="btn btn-sm btn-outline-primary position-relative">
                          <i className="bi bi-download mx-3 click-pointer-elem"></i>
                        </a>
                      </td>
                    </tr>
                  
						    	)
						    })}
              </tbody>
              

            </table>

            <div className="jan-info-close-button" onClick={this.closeHistoryBoard}><i className="bi bi-x-circle"></i></div>
          </div> 
          
          : <></>
        }

      </div>
    );
  }
}

